angular.module('com.vmware.vsphere.client.cluster')
      .constant('clusterHelpConstants', {
         DRS_FAULT_TROUBLESHOOT_GUIDE_ID: "IDH_TSMAIN"
      });
